import type { LocationQuery } from 'vue-router'
import type { TutorKanbanFilterParams } from '../interfaces'

import { parseArrayParam, parseStringParam } from '@shared/lib/url'

export const parseFilterParams = (query: LocationQuery): TutorKanbanFilterParams => {
  return {
    q: parseStringParam(query, 'q'),
    categories: parseArrayParam(query, 'categories'),
    strict_categories: parseStringParam(query, 'strict_categories'),
    paid_label: parseArrayParam(query, 'paid_label'),
    agents: parseArrayParam(query, 'agents'),
    reasons: parseArrayParam(query, 'reasons'),
    sort_by: parseStringParam(query, 'sort_by'),
    sort_direction: parseStringParam(query, 'sort_direction'),
  }
}

export const buildQueryObject = (params: TutorKanbanFilterParams): Record<string, string> => {
  const query: Record<string, string> = {}

  if (params.q) query.q = params.q
  if (params.strict_categories !== null) query.strict_categories = params.strict_categories
  if (params.sort_by) query.sort_by = params.sort_by
  if (params.sort_direction) query.sort_direction = params.sort_direction

  params.categories.forEach((v, i) => { query[`categories[${i}]`] = v })
  params.paid_label.forEach((v, i) => { query[`paid_label[${i}]`] = v })
  params.agents.forEach((v, i) => { query[`agents[${i}]`] = v })
  params.reasons.forEach((v, i) => { query[`reasons[${i}]`] = v })

  return query
}
